
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6d1f58ca&scoped=true!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./pick.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./pick.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-6d1f58ca!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./pick.vue"),
  /* scopeId */
  "data-v-6d1f58ca",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/pick.vue
// module id = 227
// module chunks = 1